<template>
  <router-view />
</template>

<script setup lang="ts">
import { captureException as newrelicCaptureException } from '@/newrelic'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ApolloError } from '@apollo/client/core'
import { useApolloClient } from '@vue/apollo-composable'
import { Plan } from '@/types/schema.generated'
import { hasAuthenticatedError } from '@/plugins/apollo'
import {
  FetchChatRedirectorDocument,
  type FetchChatRedirectorQuery,
} from './ChatRedirector.generated'

const apollo = useApolloClient()
const router = useRouter()

const redirectToChatPage = async () => {
  try {
    const { data } = await apollo.client.query<FetchChatRedirectorQuery>({
      query: FetchChatRedirectorDocument,
    })

    if (data.viewer.plan === Plan.V2022_2ManageOnlyFree) {
      // eslint-disable-next-line fp/no-mutating-methods
      await router.push({ name: 'memberChatIndex' })
      return
    }

    if (!data.uiControl.viewMatchedRooms) {
      // eslint-disable-next-line fp/no-mutating-methods
      await router.push({ name: 'assignedChatIndex' })
      return
    }

    // eslint-disable-next-line fp/no-mutating-methods
    await router.push({ name: 'ownChatIndex' })
  } catch (error) {
    if (
      error instanceof ApolloError &&
      hasAuthenticatedError(error.networkError, error.graphQLErrors)
    ) {
      return {
        route: {
          name: 'login',
        },
      }
    }

    newrelicCaptureException(error)
    throw error
  }
}

onMounted(redirectToChatPage)
</script>
